import script from "./MainImagesInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MainImagesInput.vue?vue&type=script&setup=true&lang=js"

import "./MainImagesInput.vue?vue&type=style&index=0&id=81783c5a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81783c5a"]])

export default __exports__